import styled, { css } from "styled-components";
import { md } from "styles/breakpoint";
import { theme } from "styles/theme";

const StyledLoyaltyProgramPage = styled.div`
  background-color: #222222;
  padding-top: 64px;
  .loyalty__level {
    padding: 24px 36px;
    background-color: #313135;
    border-radius: 10px;
    &-current {
      .header {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        &-level {
          width: 64px;
          height: 64px;
          background: linear-gradient(180deg, #dd3023 0%, #90241e 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;

          span {
            font-family: "Inter";
            font-style: normal;
            font-weight: 500;
            font-size: 20px;
            line-height: 30px;
            text-transform: uppercase;

            color: white;
          }
        }

        &-text {
          margin-left: 12px;

          font-weight: 600;
          font-size: 20px;
          line-height: 30px;
          color: #ffffff;
          span {
            color: #f8a01a;
            text-transform: uppercase;
          }
        }
      }
      .process {
        &-bar {
          .ant-progress {
            &-text {
              display: none;
            }
            &-outer {
              height: 12px !important;

              margin-inline-end: unset !important;
              padding-inline-end: unset !important;
            }
            &-inner {
              background-color: rgb(202, 202, 206);
              height: 100% !important;
              .ant-progress-bg {
                height: 100% !important;
                background: linear-gradient(180deg, #dd3023 0%, #90241e 100%);
              }
            }
          }
        }
        &-detail {
          display: flex;
          justify-content: space-between;
          align-items: center;
          &.--text {
            padding-top: 12px;
          }
          span {
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            color: white;
            text-transform: uppercase;

            &.--active {
              color: #f8a01a;
            }
          }
        }
      }
    }
    &-news {
      span {
        color: #b3261e;
      }
      font-style: italic;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;

      color: white;

      padding-top: 48px;
      padding-bottom: 24px;
    }
    &-conditions {
      font-weight: 600;
      font-size: 20px;
      line-height: 30px;

      color: white;
      padding-bottom: 24px;

      span {
        color: #f8a01a;
        text-transform: uppercase;
      }
    }

    .header-process {
      .header {
        display: flex;
        justify-content: space-between;
        text-align: center;
        padding-bottom: 16px;
        span {
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;

          color: white;
          &:last-of-type {
            color: #f8a01a;
          }
        }
      }
      .progress {
        .ant-progress {
          &-text {
            display: none;
          }
          &-outer {
            height: 12px !important;

            margin-inline-end: unset !important;
            padding-inline-end: unset !important;
          }
          &-inner {
            background-color: rgb(202, 202, 206);
            height: 100% !important;
            .ant-progress-bg {
              height: 100% !important;
              background: linear-gradient(180deg, #dd3023 0%, #90241e 100%);
            }
          }
        }
      }
    }
    &-deposit {
      .process {
        margin-bottom: 36px;
      }
    }
  }
  .loyalty__benefits {
    background-color: #313135;
    border-radius: 10px;
    padding: 24px 36px;

    margin-top: 24px;
    &-title {
      font-weight: 600;
      font-size: 20px;
      line-height: 30px;

      color: white;

      span {
        text-transform: uppercase;
        border-bottom: 1.5px solid #b3261e;
      }
    }
    &-list {
      padding-top: 24px;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        gap: 5px;

        span {
          font-weight: 500;
          font-size: 12px;
          line-height: 24px;

          color: #f8a01a;
        }
        p {
          font-weight: 600;
          font-size: 14px;
          line-height: 24px;

          color: white;
        }
      }
    }
  }
  .loyalty__discount {
    background-color: #313135;
    border-radius: 10px;
    padding: 24px 36px;

    margin-top: 24px;
    &-title {
      font-weight: 600;
      font-size: 20px;
      line-height: 30px;

      color: white;

      span {
        text-transform: uppercase;
        border-bottom: 1.5px solid #b3261e;
      }
    }
    &-list {
      padding-top: 24px;

      display: flex;
      align-items: center;
      justify-content: space-between;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        font-weight: 500;
        font-size: 12px;
        line-height: 24px;

        color: white;
        .percent {
          color: #f8a01a;
        }
      }
    }
  }
  ${md(css`
    padding-top: 20px;
    .loyalty__level {
      padding: 12px 10px;
      &-current {
        .header-level {
          width: 52px;
          height: 52px;
        }
        .header-text {
          font-size: 18px;
        }
      }
      .header-process {
        .header {
          padding-bottom: unset;

          span {
            font-size: 14px;
          }
        }
      }
      .process {
        margin-top: 10px;
        &-detail {
          &.--text {
            padding-top: unset;
          }
          span {
            font-size: 12px;
          }
          .item {
            img {
              width: 20px;
            }
          }
        }
      }
      &-news {
        padding-top: 22px;
        padding-bottom: 16px;
      }
      &-conditions {
        font-size: 16px;
        padding-bottom: 12px;
      }
    }
    .loyalty__benefits {
      &-title {
        font-size: 18px;
      }
      padding: 12px 10px;
      &-list {
        grid-template-columns: 1fr 1fr;
      }
    }
    .loyalty__discount {
      padding: 12px 10px;
      &-title {
        font-size: 18px;
      }
      &-list {
        padding-top: 12px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
        .item {
          border-radius: 5px;
          border: 0.5px solid ${theme.colors.primary[300]};
        }
      }
    }
  `)}
`;

export default StyledLoyaltyProgramPage;
